import { Label } from '@creanizer/ui'
import { Slider } from '@creanizer/ui'
import { Checkbox } from '@creanizer/ui'
import { Settings2 } from 'lucide-react'
import type { EventInput } from '@creanizer/types'

interface EventFormSettingsProps {
  input: EventInput
  onChange: (value: EventInput) => void
  useStreaming: boolean
  setUseStreaming: (value: boolean) => void
}

export function EventFormSettings({ input, onChange, useStreaming, setUseStreaming }: EventFormSettingsProps) {
  return (
    <div className="space-y-4 border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-2">
        <Settings2 className="w-5 h-5" />
        <h3 className="font-semibold">詳細設定</h3>
      </div>

      <div>
        <Label>創造性レベル</Label>
        <Slider
          value={[input.creativityLevel || 8]}
          onValueChange={([value]) => onChange({ ...input, creativityLevel: value })}
          min={1}
          max={10}
          step={1}
          className="mt-2"
        />
        <div className="flex justify-between text-xs mt-1">
          <span className="text-muted-foreground">保守的</span>
          <span className="font-bold">{input.creativityLevel || 8}/10</span>
          <span className="text-muted-foreground">創造的</span>
        </div>
        <p className="text-sm text-muted-foreground mt-2">
          {input.creativityLevel && input.creativityLevel >= 8 
            ? '独創的で予想外の要素を多く含みます'
            : input.creativityLevel && input.creativityLevel >= 5
            ? 'バランスの取れた内容になります'
            : '定番的で安定した内容になります'}
        </p>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="use-streaming"
          checked={useStreaming}
          onCheckedChange={(checked) => setUseStreaming(checked as boolean)}
        />
        <div className="space-y-0.5 flex-1">
          <Label htmlFor="use-streaming" className="cursor-pointer">
            ストリーミング生成
          </Label>
          <div className="text-xs text-muted-foreground">
            リアルタイムで生成過程を表示
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="use-pro"
          checked={input.useProMode || false}
          onCheckedChange={(checked) => onChange({ ...input, useProMode: checked as boolean })}
        />
        <Label htmlFor="use-pro" className="cursor-pointer">
          Pro モード（高品質・詳細な生成）
        </Label>
      </div>

      {input.useProMode && (
        <div className="bg-primary/10 rounded-lg p-3">
          <p className="text-sm">
            <strong>Proモードについて</strong>
          </p>
          <ul className="text-sm text-muted-foreground mt-2 space-y-1 list-disc list-inside">
            <li>より詳細で緻密な内容が生成されます</li>
            <li>バリエーションの多様性が向上します</li>
            <li>生成には通常より時間がかかります</li>
            <li>APIの使用量が増加します</li>
          </ul>
        </div>
      )}

      <div className="bg-muted rounded-lg p-3">
        <p className="text-xs text-muted-foreground">
          <strong>生成設定のヒント:</strong><br />
          • 創造性レベルを高くすると、より独創的なイベントが生成されます<br />
          • バリエーションレベルと創造性レベルの組み合わせで、非常に多様な結果が得られます<br />
          • Proモードは複雑なキャンペーンイベントに特に有効です
        </p>
      </div>
    </div>
  )
}